import { networkBus } from '@tunasong/models'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

export const PendingChangesBadge: FC = () => {
  const [uploads, setUploads] = useState(0)
  const [mutations, setMutations] = useState(0)

  useEffect(() => {
    const offUploads = networkBus.on('uploads-changed', payload => {
      setUploads(payload.count)
    })
    const offMutations = networkBus.on('mutations-changed', payload => {
      setMutations(payload.count)
    })
    return () => {
      offUploads()
      offMutations()
    }
  }, [])

  const total = uploads + mutations
  if (total === 0) {
    return null
  }

  return (
    <button type="button" aria-label={`${total} changes pending sync`}>
      {total} pending
    </button>
  )
}
